<template>

  <div>

    <v-card>

      <v-layout id="header">
        <v-img src="@/assets/header.jpg" gradient="to right, rgba(183,175,200,1), rgba(122,153,177,1), rgba(256,256,256,1)">
          <v-row>
            <v-col>
              <v-img id="logo" src="@/assets/logo.png"/>
            </v-col>  
          </v-row>
        </v-img>
      </v-layout>


      <v-img id="container" gradient="to bottom, rgba(122,153,177,0.1), rgba(122,153,177,0.1)">

        <v-card-title>Chiedi (in qualsiasi lingua!) e ti sarà dato</v-card-title>
        <v-card-subtitle>Questo modello di Machine Learning è in grado di rispondere alle tue domande. E in qualsiasi lingua! Leggi il paragrafo su Steve Jobs e chiedi delle informazioni su di lui. L'Intelligenza Artificiale troverà la risposta.</v-card-subtitle>

        <v-card-text>
            
            <v-row>

              <v-col cols=6>
                <Document/>
              </v-col>

              <v-col cols=6>
                <InputOutput v-bind:preparing="loading"/>
              </v-col>
            
            </v-row>  

        </v-card-text>

      </v-img>

    </v-card>

  </div>

</template>

<script>
import InputOutput from '@/components/views/InputOutput.vue'
import Document from '@/components/subcomponents/Document.vue'
import healthApi from '@/api/health.js'

export default {
  
  name: 'DemoLayout',

  components: {
    InputOutput,
    Document
  },

  data: function() {
    return {
      loading: true
    }
  },
  
  mounted: function() {
    this.loading = true
    healthApi.getHealthAnd(
      () => this.loading = false
    )
  }
  
}

</script>

<style scoped>

#header {
  overflow: hidden;
  height: 15vh;
}

#logo {
  width: 25vh;
  margin-left: auto;
  margin-right: 2vh;
}

#container {
  min-height: 70vh;
  margin: auto;
  padding-left: 10vh;
  padding-right: 10vh;
  padding-top: 5vh;
}

</style>
